import { NgModule } from '@angular/core';
import { DeleteBesichtigungCommandModule, DeleteTourCommandModule, PostBesichtigungCommandModule, PostOrdneBesichtigungenCommandModule, PostStartTourCommandModule, PostTourCommandModule } from '.';

@NgModule({
  declarations: [],
  imports: [DeleteBesichtigungCommandModule, PostBesichtigungCommandModule, PostOrdneBesichtigungenCommandModule, PostStartTourCommandModule, DeleteTourCommandModule, PostTourCommandModule],
  exports: [DeleteBesichtigungCommandModule, PostBesichtigungCommandModule, PostOrdneBesichtigungenCommandModule, PostStartTourCommandModule, DeleteTourCommandModule, PostTourCommandModule],
})
export class BesichtigungenCommandsModule {}
